module.exports = __webpack_public_path__ + "static/media/29EUNOG15.77dde9f3.jpg";